import { ComposedTheme } from '@glu/theming';

const themeOverrides = ({ palette: { background, colors, primary, text } }: ComposedTheme) => ({
  alerts: {
    positive: {
      backgroundColor: background,
      color: colors?.mineShaft || '#333333',
      borderColor: colors?.emerald || '#32C846',
      positiveIconFill: colors?.emerald || '#32C846'
    },
    negative: {
      backgroundColor: background,
      color: colors?.mineShaft || '#333333',
      borderColor: colors?.red || '#DF0000',
      negativeIconFill: colors?.red || '#DF0000'
    },
    warning: {
      backgroundColor: background,
      color: colors?.mineShaft || '#333333',
      borderColor: colors?.yellowOrange,
      warningIconFill: colors?.yellowOrange
    },
    info: {
      backgroundColor: background,
      color: colors?.mineShaft || '#333333',
      borderColor: colors?.dodgerBlue,
      infoIconFill: colors?.dodgerBlue
    }
  },
  popover: {
    content: {
      backgroundColor: {
        defaultBackgroundColor: background
      },
      color: {
        negativeColor: text?.dark
      }
    }
  },
  actionableIcon: {
    backgroundColor: background,
    color: primary.normal,
    disabledColor: primary.disabled,
    borderColor: primary.light,
    hoverColor: text.light,
    hoverBackgroundColor: primary.normal
  }
});

export default themeOverrides;
